import axios from 'axios';

const getVideoAccessToken = async (roomId: string, identity: string) => {
  const { data: token } = await axios.get<string>(
    `/virtual_tour_page_info/${roomId}/video_access_token`,
    {
      params: {
        identity,
      },
    },
  );

  return token;
};

export default getVideoAccessToken;
